<template>
  <div id="FiltroAcuerdosClientes">
    
    <div class="w-100">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal')"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="limpiar()"
        />
      </div>
    </div>

    <ui-modal ref="modal" title="Filtros para tabla" size="large" @close="ActionSetZindexTablaModal(false)">
      <div class="d-flex flex-column">
        <div class="d-flex">
          <!-- Clientes -->
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Clientes"
            :options="clientes"
            placeholder="Seleccionar"
            multiple
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroClientesModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Naviera"
            placeholder="Seleccionar"
            :options="navieras"
            multiple
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroNavieraModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Naviera Salida"
            placeholder="Seleccionar"
            :options="dataListaNavierasNoUCC"
            multiple
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroNavieraSalidaModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Destino"
            :options="destinos"
            multiple
            placeholder="Seleccionar"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            @change="getPODByDestination()"
            v-model="filtroDestinoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="POL"
            multiple
            :options="puertos"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroPolModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="POD"
            :options="filtroDestinoModel.length === 0 ? pod : podListByDestination"
            multiple
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :disabled="podListDisabled"
            v-model="filtroPodModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <date-picker
            class="w-100 mr-2"
            style="margin-left: -2px; font-size: 22px"
            type="datet"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Desde"
            v-model="filtroDesdeModel"
          />
          <date-picker
            class="w-100 mr-1 ml-1"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Hasta"
            v-model="filtroHastaModel"
          />
          <div class="w-100 ml-2">
            <ui-switch @change="busquedaEspecificaChange()" v-model="busquedaEspecifica">Búsqueda Fecha Específica
            </ui-switch>
          </div>
        </div>
        <div class="d-flex mt-5">
          <date-picker
            class="w-100 mr-2"
            type="date"
            value-type="format"
            @close="handleOpenChange"
            placeholder="Vigencia"
            v-model="filtroVigenciaModel"
          />
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Tipo contrato"
            :options="tipoContratos"
            placeholder="Seleccionar"
            @change="searchContracts();"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            v-model="filtroTipoContratoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Contrato"
            placeholder="Seleccionar"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            :options="contracts"
            v-model="filtroContratoModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Producto"
            multiple
            placeholder="Seleccionar"
            :options="commodity"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            v-model="filtroProductoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Tipo contenedor"
            placeholder="Seleccionar"
            :options="contenedores"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroTipoContenedorModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Estado"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ label: 'name', value: 'id' }"
            v-model="filtroEstadoModel"
            :options="estados"
          />
        </div>
        <div class="d-flex mt-5">
          <div class="col-4 pl-0">
            <ui-select
              class="w-100"
              has-search
              label="Get Out"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="filtroGetOutModel"
              :options="[
                  {id: 1, name: 'Si'},
                  {id: 0, name: 'No'}
                  ]">
            </ui-select>
          </div>

          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              label="Trat. frío"
              placeholder="Seleccionar"
              :keys="{ value: 'id', label: 'name' }"
              searchPlaceholder="Buscar"
              :options="coldtreatmentList"
              v-model="filtroColdtreatmentModel">
            </ui-select>
          </div>

          <div class="col-4 pr-0">
            <ui-textbox
              type  = "number"
              class = "w-100"
              floating-label
              v-model="tariff_line_id"
              label = "ID Tariff Line"
            />
          </div>
        </div>

        <!-- Footer -->
        <div class="d-flex justify-content-between mt-5">
          <button class="btn btn-default" @click="closeModal('modal')">
            Cerrar
          </button>
          <div style="float: right">
            <button
              class="btn btn-outline-secondary"
              @click="resetForm()"
              style="margin-right: 15px">
              Limpiar
            </button>
            <button
              class="btn btn-outline-primary"
              id="buttonRef"
              @click="filtrar()">
              Filtrar
            </button>
          </div>
        </div>
      </div>
    </ui-modal>
    
  </div>
</template>

<script>
// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiModal from "keen-ui/src/UiModal";
import UiSwitch from "keen-ui/src/UiSwitch";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

import Button from "../../../common/Button";
import {
  getAcuerdosClientes,
  getAcuerdosClientesFiltros,
  getContratosPorNavieraYTipo,
  getPODByDestination,
  getListasAcuerdosBase
} from "@/constants/lineas";
import { mapActions, mapState } from "vuex";

export default {
  props: ["data", "dataInicial", "getListaAcuerdosClientes", "limpiarChecks"],
  data() {
    return {
      filtroClientesModel: [],
      filtroNavieraModel: [],
      filtroNavieraSalidaModel: [],
      filtroPolModel: [],
      filtroPodModel: [],
      filtroDestinoModel: [],
      filtroProductoModel: [],
      filtroDesdeModel: "",
      filtroHastaModel: "",
      filtroVigenciaModel: "",
      filtroTipoContratoModel: "",
      filtroContratoModel: "",
      filtroTipoContenedorModel: "",
      filtroEstadoModel: "",
      filtroGetOutModel: "",
      filtroColdtreatmentModel: "",
      coldtreatmentList: [],
      dataAux: this.data,
      filtroBusquedaEspecificaDesdeModel: "",
      filtroBusquedaEspecificaHastaModel: "",
      contracts: [],
      busquedaEspecifica: false,
      podListByDestination: [],
      podListDisabled: false,
      tariff_line_id : ""
    };
  },
  components: {
    UiSelect,
    Button,
    UiModal,
    DatePicker,
    UiSwitch
  },
  computed: {
    ...mapState([
      "contratos",
      "clientes",
      "navieras",
      "pol",
      "pod",
      "puertos",
      "destinos",
      "commodity",
      "tipoContratos",
      "contenedores",
      "estados"
    ]),
    ...mapState("lineas", [
      "dataListaNavierasNoUCC"
    ])
  },
  methods: {
    ...mapActions(["ActionSetShowAcuerdoClientes", "ActionSetZindexTablaModal"]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosClientes",
      "actionSetFormFiltroAcuerdoCliente",
      "actionSetFilterStateAcuerdosClientes"
    ]),
    async getPODByDestination() {

      if (this.filtroDestinoModel.length > 0) {

        this.podListDisabled = true;

        this.filtroPodModel = [];

        this.podListByDestination = await getPODByDestination({ "destinations": this.filtroDestinoModel.map(p => +p.id) ?? [] });

        this.podListDisabled = false;
      }

    },
    openModal(ref) {
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async searchContracts() {

      const form = { type: +this.filtroTipoContratoModel.id };
      this.contracts = await getContratosPorNavieraYTipo(form);
    },
    busquedaEspecificaChange() {

      if (this.busquedaEspecifica) {
        this.filtroBusquedaEspecificaHastaModel = this.filtroHastaModel;
        this.filtroBusquedaEspecificaDesdeModel = this.filtroDesdeModel;
      } else {
        this.filtroBusquedaEspecificaHastaModel = "";
        this.filtroBusquedaEspecificaDesdeModel = "";
      }
    },
    resetForm() {
      this.filtroClientesModel = [];
      this.filtroNavieraModel = [];
      this.filtroNavieraSalidaModel = [];
      this.filtroPolModel = [];
      this.podListByDestination = [];
      this.filtroPodModel = [];
      this.filtroDestinoModel = [];
      this.filtroProductoModel = [];
      this.filtroDesdeModel = "";
      this.filtroHastaModel = "";
      this.tariff_line_id = "";
      this.filtroVigenciaModel = "";
      this.filtroTipoContratoModel = {};
      this.filtroContratoModel = {};
      this.filtroTipoContenedorModel = {};
      this.filtroEstadoModel = {};
      this.filtroGetOutModel = '';
      this.filtroColdtreatmentModel = "";
      this.contracts = [];
      this.actionSetFilterStateAcuerdosClientes(null);
    },

    async limpiar() {

      this.resetForm();

      this.$vToastify.loader("Recargando tabla...");

      const { data_table } = await getAcuerdosClientes();

      await this.actionSetDataListarTarifasAcuerdosClientes(data_table);

      this.$vToastify.stopLoader();
      
    },
    async filtrar() {
      
      this.ActionSetShowAcuerdoClientes(true);

      const form = {
        client_id: this.filtroClientesModel.map(c => +c.id) ?? [],
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => +n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.map(d => +d.id) ?? [],
        products_category_id: this.filtroProductoModel.map(p => +p.id) ?? [],
        from_date: this.filtroDesdeModel,
        to_date: this.filtroHastaModel,
        vigencia: this.filtroVigenciaModel,
        tipo_contrato: this.filtroTipoContratoModel.id ?? "",
        tariff_contract_id: this.filtroContratoModel.id ?? "",
        coldtreatment: this.filtroColdtreatmentModel.name ?? "",
        container_id: this.filtroTipoContenedorModel.id ?? "",
        estado: this.filtroEstadoModel.id ?? "",
        from_date_specific: this.filtroBusquedaEspecificaDesdeModel ?? "",
        to_date_specific: this.filtroBusquedaEspecificaHastaModel ?? "",
        ids: this.dataInicial.map(d => d.data_complementaria.id),
        get_out: this.filtroGetOutModel.id ?? null,
        tariff_line_id: !this.tariff_line_id ? null : this.tariff_line_id,
      };
      
      this.limpiarChecks();
      
      this.estadoButton("Filtrando...");
      
      this.$vToastify.loader("Filtrando...");

      if (
        form.client_id === []
        && form.naviera_id === []
        && form.pol === []
        && form.pod === []
        && form.destination_id === []
        && form.products_category_id === []
        && form.from_date === ""
        && form.to_date === ""
        && form.vigencia === ""
        && form.tipo_contrato === ""
        && form.tariff_contract_id === ""
        && form.coldtreatment === ""
        && form.container_id === ""
        && form.estado === ""
        && form.get_out === ""
      ) {

        this.actionSetFilterStateAcuerdosClientes(null);

      } else {

        this.actionSetFilterStateAcuerdosClientes(form);

      }

      try {
        const { data_table } = await getAcuerdosClientesFiltros(form);

        await this.actionSetDataListarTarifasAcuerdosClientes(data_table);

        this.$vToastify.stopLoader();

        this.estadoButton("Filtrar", false);

        this.closeModal("modal");

      } catch (error) {

        this.$vToastify.stopLoader();

        this.estadoButton("Filtrar", false);

        return this.$vToastify.error(
          "Hubo un problema al filtrar datos, recargue la página y vuelva a intentar.",
          "Lo sentimos"
        );

      }
    }
  },
  async created() {
    const { lista_coldtreatment } = await getListasAcuerdosBase();
    this.coldtreatmentList = lista_coldtreatment || [];
  }
}
</script>

<style>
#FiltroAcuerdosClientes .mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}
</style>
